import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

const BADGE_IMAGES = {
  bronze: 'https://customer-assets.emergentagent.com/job_4aa49966-0453-4121-936d-b4d2175c3c82/artifacts/wxgk5bmz_Bronze%20Sustainable%20Host.png',
  silver: 'https://customer-assets.emergentagent.com/job_4aa49966-0453-4121-936d-b4d2175c3c82/artifacts/fen5dc8s_Silver%20Sustainable%20Host.png',
  gold:   'https://customer-assets.emergentagent.com/job_4aa49966-0453-4121-936d-b4d2175c3c82/artifacts/auxjpbmp_Gold%20Sustainable%20Host.png',
};

const TIER_LABEL = {
  bronze: 'Bronze Sustainable Host',
  silver: 'Silver Sustainable Host',
  gold:   'Gold Sustainable Host',
};

const SIZE_PX = { sm: 36, md: 56, lg: 96 };

/**
 * Sustainability tier badge using custom GeoStays artwork.
 * Props: tier ('bronze'|'silver'|'gold'), score (optional), size ('sm'|'md'|'lg')
 */
const SustainabilityBadge = ({ tier, score, size = 'sm', className = '' }) => {
  if (!tier || !BADGE_IMAGES[tier]) return null;
  const px = SIZE_PX[size] || SIZE_PX.sm;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid={`sustainability-badge-${tier}`}
            onClick={(e) => e.stopPropagation()}
            className={`inline-flex items-center justify-center ${className}`}
            style={{ width: px, height: px }}
          >
            <img
              src={BADGE_IMAGES[tier]}
              alt={TIER_LABEL[tier]}
              loading="lazy"
              className="object-contain drop-shadow-sm"
              style={{ width: px, height: px }}
            />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <p className="text-xs font-semibold mb-1">{TIER_LABEL[tier]}</p>
          <p className="text-xs text-gray-200">
            Verified by GeoStays admin against the Sustainability Checklist
            {typeof score === 'number' && <> · scored {score}/10</>}.
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default SustainabilityBadge;
